/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlErrorCode } from './ControlErrorCode';
import {
    ControlErrorCodeFromJSON,
    ControlErrorCodeFromJSONTyped,
    ControlErrorCodeToJSON,
} from './ControlErrorCode';
import type { ControlErrorCodesAndDetails } from './ControlErrorCodesAndDetails';
import {
    ControlErrorCodesAndDetailsFromJSON,
    ControlErrorCodesAndDetailsFromJSONTyped,
    ControlErrorCodesAndDetailsToJSON,
} from './ControlErrorCodesAndDetails';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {ControlErrorCode}
     * @memberof Message
     */
    error_code: ControlErrorCode;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    text: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Message
     */
    detail?: { [key: string]: any; };
}

/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error_code" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error_code': ControlErrorCodeFromJSON(json['error_code']),
        'text': json['text'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
    };
}

export function MessageToJSON(value?: Message | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error_code': ControlErrorCodeToJSON(value.error_code),
        'text': value.text,
        'detail': value.detail,
    };
}

